export default __webpack_public_path__ + "static/media/node.0316be11.svg";